import { Button as MuiButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getIconComponentByType } from "../../utils/assets";

const PrimaryStyled = styled(MuiButton)(({ theme }) => ({
  ...theme.typography.button,
  color: `${theme.palette.black} !important`,
  backgroundColor: `${theme.palette.primary.main} !important`,
  padding: theme.spacing(2),
  margin: 0,
  borderRadius: 8,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: `${theme.palette.primary.dark || theme.palette.primary.main} !important`,
  },
  height: 37,
}));

const SecondaryStyled = styled(MuiButton)(({ theme }) => ({
  ...theme.typography.button,
  color: `${theme.palette.white} !important`,
  backgroundColor: `${theme.palette.secondary.dark} !important`,
  padding: theme.spacing(2),
  margin: 0,
  borderRadius: 8,
  boxShadow: "none",
  "&:hover": {
    backgroundColor: `${theme.palette.secondary.dark} !important`,
  },
  height: 37,
}));

const TYPE = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  START: "start",
  END: "end",
};

export default function Button({
  label,
  variant = "contained",
  type = TYPE.PRIMARY,
  iconPosition = TYPE.START,
  iconType,
  ...props
}) {
  const newProps = { ...props };

  if (iconType) {
    const key = iconPosition === TYPE.END ? "endIcon" : "startIcon";
    newProps[key] = getIconComponentByType(iconType);
  }

  return (
    type === TYPE.PRIMARY ? (
      <PrimaryStyled variant={variant} {...newProps}>
        {label}
      </PrimaryStyled>
    ) : (
      <SecondaryStyled variant={variant} {...newProps}>
        {label}
      </SecondaryStyled>
    )
  );
}
